// index.ts
import { DesignSystem } from "@adornis/chemistry/elements/theming/design";
import "@adornis/chemistry/elements/x-components";
import "@adornis/fonts/fonts";
import "./components/ge-basic-date-picker";
import "./components/ge-date-picker-dropdown";
import "./components/ge-card";
import "./components/ge-flex";
import "./components/ge-grid";
import "./components/ge-icon";
import "./components/ge-loader";
import "./components/ge-radiogroup";
import "./fonts";
import "./global-style";
import "./theme";
DesignSystem.prefix = "ge";
DesignSystem.useTheme("ge");
